module.exports = __webpack_public_path__ + "img/f150-21.cad034a4.jpg";